import axios from 'axios';
// import {config} from '../../public/config'

const { 
REACT_APP_BASE_URL_GIS_SERVER,

REACT_APP_BASE_URL_GIS_SCADA_SERVER } = window['runConfig'];

export const mock = axios.create({
    baseURL: 'https://my.api.mockaroo.com',
    timeout: 50000,
    headers: { 'X-API-Key': '0de564c0' }
});

export const fetch = axios.create({
    // baseURL: 'https://cors-anywhere.herokuapp.com/https://gis.exxor.com.my', // host api that
    // baseURL: 'https://nrw.intelli.com.vn/DotNet/proxy.ashx?https://gis.exxor.com.my', // host api that
    // baseURL: 'https://www.thodev.localhost.com/DotNet/proxy.ashx?https://gis.exxor.com.my', // host api that
    // baseURL: `${REACT_APP_PROXY_URL}?${REACT_APP_BASE_URL_GIS_SERVER}`,
    // baseURL: `${REACT_APP_PROXY_URL}?${REACT_APP_BASE_URL_GIS_SERVER}`,
    baseURL: `${REACT_APP_BASE_URL_GIS_SERVER}`,


    // baseURL: 'https://gis.exxor.com.my', // host api that
    timeout: 50000,
    // headers: {
    //     'Authorization': 'Bearer knar8lfqlg6jQH3yj7jLDPyl2PsnJOQZlJSk-chwwzCwsgl-Y7ld2zAszx6B5E03YeN05rpUSnDM7CIKe8uj-rCtsAgADUosd_5Wbvz6-w37gJdfA3w4Vf0U8FendDZiJ5YmdPn0ESiOjHjtqijuLPNlLyVrbKxy3pwdPWnxQ5k.'
    // }
    // headers: {'Origin': 'http://localhost/DotNet/proxy.ashx'}
    headers: {
        'X-XSS-Protection': '1; mode=block',
        'Strict-Transport-Security': 'max-age=31536000; includeSubDomains'
      
        // 'Accept': 'application/json',
        // 'Content-Type': 'application/json',
        // "X-Requested-With": null
        // "Content-Type":"text/plain"
    }
});

export const fetch_scada_server = axios.create({
    // baseURL: 'https://apiscada.intelli.com.vn', // host api that old
    // baseURL: 'https://www.thodev.localhost.com/DotNet/proxy.ashx?https://scada.exxor.com.my', // host api that new

    // baseURL: `${REACT_APP_PROXY_URL}?${REACT_APP_BASE_URL_GIS_SCADA_SERVER}`,
    baseURL: `${REACT_APP_BASE_URL_GIS_SCADA_SERVER}`,

    // baseURL: 'https://nrw.intelli.com.vn/DotNet/proxy.ashx?https://scada.exxor.com.my', // host api that new
    // baseURL: 'https://gis.exxor.com.my', // host api that
    timeout: 100000,
    // headers: {
    //     'Authorization': 'Bearer knar8lfqlg6jQH3yj7jLDPyl2PsnJOQZlJSk-chwwzCwsgl-Y7ld2zAszx6B5E03YeN05rpUSnDM7CIKe8uj-rCtsAgADUosd_5Wbvz6-w37gJdfA3w4Vf0U8FendDZiJ5YmdPn0ESiOjHjtqijuLPNlLyVrbKxy3pwdPWnxQ5k.'
    // }
    headers: {
        'X-XSS-Protection': '1; mode=block',
        'Strict-Transport-Security': 'max-age=31536000; includeSubDomains'
    }
});

//--------------------------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------------------------


// export default fetch
// https://my.api.mockaroo.com/calculator_table.json?key=0de564c0

//https://cors-anywhere.herokuapp.com/https://gis.exxor.com.my/arcgis/rest/services/Serian/DMA_NRW_V2/FeatureServer/1/addFeatures
//inital kelantan